export const defaultColors = [
    "#000000",
    "#ffffff",
    "#FFFF02",
    "#00FF00",
    "#007900",
    "#00AEAE",
    "#0600FF",
    "#7307A5",
    "#BA00FF",
    "#CD00AF",
    "#FF0000",
    "#FF4600",
    "#FF7F01",
    "#FEB400",
];
